import { mdiAccount, mdiAccountMultiple } from '@mdi/js'
import Icon from '@mdi/react'
import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Flex } from '@/components/ui/flex'
import { HStack } from '@/components/ui/stack'
import { Text } from '@/components/ui/typography'
import { useColorMode } from '@/hooks/useColorMode'
import { TIntegratedSystems } from '@/types/tasksApprovals'

const Container = ({
    id,
    isSelected,
    myCompliances,
    directsCompliances,
    textColor,
}: {
    id: TIntegratedSystems
    isSelected: boolean
    myCompliances?: number
    directsCompliances?: number
    textColor: string
}) => {
    const { t } = useTranslation()
    const { colorMode } = useColorMode()
    const iconColor = isSelected || colorMode !== 'light' ? 'var(--chakra-colors-white)' : 'var(--chakra-colors-dark-700)'
    return (
        <>
            <Box divideX="2px" height="50px" />
            {id !== 'MY_LEARNING' && (
                <>
                    <Flex flexDir="column" flexGrow="1" mr="8px">
                        <HStack mb="12px">
                            <Icon path={mdiAccount} size="11px" color={iconColor} />
                            <Flex justifyContent="space-between" flexGrow="1">
                                <Text fontSize="12px" letterSpacing="1px" color={textColor}>
                                    {t('tasksApprovals.widgets.forYou')}
                                </Text>
                                <Text fontSize="12px" letterSpacing="1px" color={textColor} fontFamily="GSKPrecision-Bold">
                                    {myCompliances}
                                </Text>
                            </Flex>
                        </HStack>
                        <HStack>
                            <Icon path={mdiAccountMultiple} size="11px" color={iconColor} />
                            <Flex justifyContent="space-between" flexGrow="1">
                                <Text fontSize="12px" letterSpacing="1px" color={textColor}>
                                    {t('tasksApprovals.widgets.directs')}
                                </Text>
                                <Text fontSize="12px" letterSpacing="1px" color={textColor} fontFamily="GSKPrecision-Bold">
                                    {directsCompliances}
                                </Text>
                            </Flex>
                        </HStack>
                    </Flex>
                </>
            )}
        </>
    )
}

export default Container
